import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SSNPipe } from './app.SSN.pipe';
import { EINPipe } from './app.EIN.pipe';
import { RoundPipe } from './round.pipe';
import { columnPipe, rowPipe, searchPipe } from './filter.pipe';
import { CurrencyFormatPipe } from './app.currency.pipe';

@NgModule({
    imports: [
      CommonModule
    ],
    declarations: [
        SSNPipe,
        EINPipe,
        RoundPipe,
        columnPipe,
        rowPipe,
        searchPipe,
        CurrencyFormatPipe
    ],
    exports: [
        SSNPipe,
        EINPipe,
        RoundPipe,
        columnPipe,
        rowPipe,
        searchPipe,
        CurrencyFormatPipe
      
    ]
  })
  export class PipesModule {
  }
  


// WEBPACK FOOTER //
// ./src/app/pipes/pipes.module.ts